import React, { Component } from "react"
import { Seo } from "../components/Seo"
import Styles from "./TextContent.module.css"

class FAQ extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <section className={[Styles.pageContent, Styles.container].join(" ")}>
        <h2>Usein kysytyt kysymykset</h2>
        <h3>Verotiedot</h3>
        <p>
          Yritystietopalvelussa käytetään Verohallinnon avoimena datana tarjoamaa tietoa yritysten 
          maksuunpannuista veroista yhteensä. Tiedot esitetään yrityksen ilmoittaman kotikunnan ja verovuoden 
          mukaan. Tieto päivittyy kerran vuodessa.
        </p>
        <p>
          Palveluun on toivottu myös tietoa suurimmista yhteisöveron maksajista kunnittain. 
          Tieto ei ole avointa, joten sitä ei pystytä esittämään palvelussa.
        </p>
        <h3>Aktiivisen yrityksen määritelmä</h3>
        <p>
          Yritys on aktiivinen, kun se on rekisteröity kaupparekisteriin sekä vähintään yhteen toiseen 
          rekisteriin (ALV-rekisteriin, ennakkoperintärekisteriin, tai työnantajarekisteriin) tai 
          yrityksellä on vähintään yksi tilinpäätös viimeiseltä kolmelta tilikaudelta, eikä sillä ole 
          mitään erityistilannetta (konkurssi, saneeraus, selvitystila, toiminta keskeytynyt tai 
          toiminta lakannut). Viimeisen kuuden kuukauden sisään perustetut yritykset ovat automaattisesti 
          aktiivisia. Sisältää seuraavat yhtiömuodot: Oy, Oyj, Tmi, Ky, Ay ja Osk. Määritelmä eroaa 
          Tilastokeskuksen yrityskannan määritelmästä. 
        </p>
        <h3>Yrityksen sijainnin määrittyminen</h3>
        <p>
          Käyttäjä pystyy suodattamaan ja tarkastelemaan yrityksiä yrityksen kotikunnan ja/tai yrityksen 
          toimipaikan sijainnin mukaan. Mikäli käyttäjä on valinnut yritykset kotikunnan mukaan, 
          valittu kunta on yritysten kotikunta. Mikäli käyttäjä on valinnut yrityksen sijainnin mukaan, 
          valittu kunta on yrityksen toimipaikkojen sijaintikunta.
        </p>
        <h3>Päätoimipaikat ja sivutoimipaikat</h3>
        <p>
          Useilla yrityksillä on päätoimipaikkansa lisäksi sivutoimipaikkoja. Tilastoissa saattaa kuitenkin 
          olla niin, että yrityksen toiminta ja taloudellinen aktiivisuus kirjautuu pelkästään päätoimipaikan 
          mukaan. Tämän vuoksi yritystietopalvelua on rikastettu erikseen hankitulla sivutoimipaikkatiedolla, 
          joka näkyy muun muassa yrityslistauksissa ja karttakuvaajissa. Mm. taloustiedot näkyvät ainoastaan 
          yrityksen päätoimipaikoilla.
        </p>
        <h3>Business Finlandin myöntämä rahoitus</h3>
        <p>Rahoituksen kunta määräytyy projektin toteutuskunnan mukaan.</p>
        <h3>Kuntakohtaiset henkilöstötiedot</h3>
        <p>
          Kuntakohtaiset henkilöstötiedot perustuvat Tilastokeskuksen yritysrekisteriin ja kertovat y
          rityksen kuntakohtaisen henkilöstön lukumäärän. Toimipaikkakohtaisia henkilöstömääriä 
          ei ole saatavilla.
        </p>
        <h3>Palvelun ylläpito ja yhteyshenkilöt </h3>
        <p>
          Palvelua kehitetään Business Tampereessa yhteistyössä alueen elinkeinotoimijoiden ja 
          yritystiedon käyttäjien kanssa. Palvelun tekninen kehittämiskumppani 
          on <a href="https://peanutsgroup.com">Peanuts Group Oy</a>.
        </p>
        <h4>Haluatko kuulla lisää tai osallistua palvelun kehittämiseen?</h4>
        <p>Ota yhteyttä:</p>
        <span>Elina Suuronen</span>
        <span>Analyytikko</span>
        <span>Business Tampere</span>
        <a href="mailto:elina.suuronen@businesstampere.com">
          elina.suuronen@businesstampere.com
        </a>
        <Seo title="Usein kysytyt kysymykset" />
      </section>
    )
  }
}

export default FAQ
